import axios from 'axios'
import {
  Message
} from 'element-ui'
import Router from '../router'

import Qs from 'qs'
const service = axios.create({
  baseURL: '/api',
  withCredentials: true,
  crossDomain: true,
  timeout: 80000 // request timeoutrequest
})

service.interceptors.request.use(config => {
  //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
  // console.log(config)
  if (config.hasFile == 'hasFile') {
    // config.data = config.params; //  含有文件,不转换
    console.log(config.data)
    config.headers = {
      'Content-Type': 'multipart/form-data', //配置请求头
      'Authorization': window.localStorage.getItem('token')
    }
  } else {
    // console.log('hasFile2')
    config.headers = {
      'Authorization': window.localStorage.getItem('token')
    }
  }
  config.withCredentials = true
  //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
  // const session = getCookie('laravel_session'); //这里取token之前，你肯定需要先拿到token,存一下
  // console.log(session)
  // if (session) {
  //   config.params = {'token':token} //如果要求携带在参数中
  //   config.headers.cookie = session; //如果要求携带在请求头中
  // }
  return config
}, error => {
  Promise.reject(error)
})
service.interceptors.response.use(response => {
  //接收到响应数据并成功后的一些共有的处理，关闭loading等
  // if(true){  //链接过期返回登录页
  //     console.log('请求成功')
  // }

  return response.data || null
}, error => {
  /***** 接收到异常响应的处理开始 *****/
  if (error && error.response) {
    // 1.公共错误处理
    // 2.根据响应码具体处理
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break;
        case 401:
          error.message = '未授权，请重新登录'
          localStorage.removeItem('token')
          localStorage.removeItem('hospAccount')
          localStorage.removeItem('hosLogo')
          localStorage.removeItem('hosName')
          Router.push("/login")
          break;
      case 403:
        error.message = '拒绝访问'
        break;
      case 404:
        error.message = '请求错误，请检查您的网络'
        // window.location.href = "/NotFound"
        break;
      case 405:
        error.message = '请求方法未允许'
        break;
      case 408:
        error.message = '请求超时'
        break;
      case 500:
        error.message = '服务器端出错'
        break;
      case 501:
        error.message = '网络未实现'
        break;
      case 502:
        error.message = '网络错误'
        break;
      case 503:
        error.message = '服务不可用'
        break;
      case 504:
        error.message = '网络超时'
        break;
      case 505:
        error.message = 'http版本不支持该请求'
        break;
      default:
        error.message = `连接错误${error.response.status}`
    }
  } else {
    // 超时处理
    if (JSON.stringify(error).includes('timeout')) {
      Message.error('服务器响应超时，请刷新当前页')
    }
    error.message('连接服务器失败')
  }

  Message.error(error.message)
  /***** 处理结束 *****/
  //如果不需要错误处理，以上的处理过程都可省略
  return Promise.resolve(error.response)
})
export default service



// WEBPACK FOOTER //
// ./src/util/request.js